import { Box, TextField } from '@mui/material';
import React from 'react';
import { StyledButton } from '../../styles/StyledButtons';
import StyledModal from '../../styles/StyledModal';

interface ContactFundOpportunityKanbanInvestmentPromptModalProps {
  open: boolean;
  title?: string;
  value?: string;
  error?: string;
  onClose: () => void;
  onValueChange: (value: string) => void;
  onSubmit: () => void;
}

export function ContactFundOpportunityKanbanInvestmentPromptModal({
  open,
  title,
  value,
  error,
  onClose,
  onValueChange,
  onSubmit,
}: ContactFundOpportunityKanbanInvestmentPromptModalProps) {
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      title={title || 'Investment Amount'}
      tone="tone1"
      actions={
        <>
          <StyledButton variant="outlined" onClick={onClose}>
            Cancel
          </StyledButton>
          <StyledButton variant="contained" onClick={onSubmit} disabled={!value}>
            Submit
          </StyledButton>
        </>
      }
    >
      <Box p={3}>
        <TextField
          type="number"
          value={value || ''}
          onChange={(event) => onValueChange(event.target.value)}
          autoFocus
          fullWidth
          error={!!error}
          helperText={error || 'Enter investment amount'}
          inputProps={{ min: 100000, step: 25000 }}
          sx={{ mt: 2 }}
        />
      </Box>
    </StyledModal>
  );
}
